import api from "./api";

// 生成會話 ID
const generateSessionId = () => {
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 15);
    return `session_${timestamp}_${random}`;
};

// 獲取或創建會話 ID
const getSessionId = () => {
    let sessionId = sessionStorage.getItem('tracking_session_id');
    if (!sessionId) {
        sessionId = generateSessionId();
        sessionStorage.setItem('tracking_session_id', sessionId);
    }
    return sessionId;
};

// 記錄貼文瀏覽
export const trackPostView = async (postId, clickedFrom = null) => {
    try {
        const sessionId = getSessionId();
        
        // 優先使用傳入的 clickedFrom，然後檢查 sessionStorage，最後使用 referrer
        let sourceFrom = clickedFrom;
        if (!sourceFrom) {
            sourceFrom = sessionStorage.getItem('post_clicked_from');
            if (sourceFrom) {
                // 使用後立即清除，避免影響後續瀏覽
                sessionStorage.removeItem('post_clicked_from');
            } else {
                sourceFrom = document.referrer || 'direct';
            }
        }
        
        const response = await api.post(`posts/${postId}/track-view/`, {
            session_id: sessionId,
            clicked_from: sourceFrom
        });
        return response.data;
    } catch (error) {
        console.error("Failed to track post view:", error);
        // 不要讓 tracking 錯誤影響用戶體驗
        return null;
    }
};

// 更新停留時間和滾動深度
export const updateDwellTime = async (postId, dwellTime, scrollDepth = 0) => {
    try {
        const sessionId = getSessionId();
        const response = await api.put(`posts/${postId}/update-dwell-time/`, {
            session_id: sessionId,
            dwell_time: dwellTime,
            scroll_depth: Math.min(100, Math.max(0, scrollDepth)) // 確保在 0-100 範圍內
        });
        return response.data;
    } catch (error) {
        console.error("Failed to update dwell time:", error);
        // 不要讓 tracking 錯誤影響用戶體驗
        return null;
    }
};

// 計算滾動深度百分比
export const calculateScrollDepth = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (documentHeight <= windowHeight) {
        return 100; // 如果頁面高度不超過視窗高度，認為已經看完全部
    }
    
    const scrollableHeight = documentHeight - windowHeight;
    const scrollPercent = (scrollTop / scrollableHeight) * 100;
    
    return Math.min(100, Math.max(0, Math.round(scrollPercent)));
};

// Tracking hook for post viewing
export const usePostTracking = (postId) => {
    const sessionId = getSessionId();
    
    const trackView = (clickedFrom) => {
        return trackPostView(postId, clickedFrom);
    };
    
    const updateTime = (dwellTime, scrollDepth) => {
        return updateDwellTime(postId, dwellTime, scrollDepth);
    };
    
    return {
        sessionId,
        trackView,
        updateTime,
        calculateScrollDepth
    };
};
